import { PersonPage } from '../components/PersonPage';

export function Groom() {
  return (
    <PersonPage
      role="The Groom"
      name="Andi Samijono"
      tagline="Curious, thoughtful, and quietly determined."
      bio="Andi is an Indonesian-born, Malaysia-raised, Australian citizen and Technical Lead (Software) based in Perth. Curious, thoughtful, and quietly determined, he loves building things, solving problems, and dreaming big. Beneath his calm exterior, he has a soft heart — especially when it comes to Lynne."
      interests={[]}
      hero="/people/groom-1.jpeg"
      gallery={[
        '/people/groom-2.jpeg',
        '/people/groom-3.jpg',
        '/people/groom-4.jpg',
        '/people/groom-5.jpg',
      ]}
    />
  );
}
